import { render, staticRenderFns } from "./video-manage-list.vue?vue&type=template&id=4788a404&scoped=true"
import script from "./video-manage-list.vue?vue&type=script&lang=js"
export * from "./video-manage-list.vue?vue&type=script&lang=js"
import style0 from "./video-manage-list.vue?vue&type=style&index=0&id=4788a404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4788a404",
  null
  
)

export default component.exports